import { StorageSerializers } from "@vueuse/core";

export default async <T>(url: string) => {
  // Use Session storage to  cache the data
  const cached = useSessionStorage<T>(url, null, {
    // By passing null as default it can't automatically infer the type
    // Determine which serializer to use
    serializer: StorageSerializers.object,
  });

  if (true) { // by pass using fetch
    // if (!cached.value) {
    const { data, error, status } = await useFetch<T>(url, {
      lazy: false,
      key: "useFetchWithCache",
    });

    if (error.value) {
      throw createError({
        status: 404,
        message: `Could not fetch data from ${url}`,
      });
    }

    cached.value = data.value as T;
  } else {
    console.log(`Getting value from cache for ${url}`);
  }

  return cached;
};
